import React from 'react';
import { Flex, Button } from '@chakra-ui/react';
import HeaderFont from '@components/atoms/HeaderFont';
// TODO: add correct favicon when available from design.
import { FiShare } from '@react-icons/all-files/fi/FiShare';
import ShareOnSocial from 'react-share-on-social';
import favicon from '../../../static/fav_icon.png';

const SharePageBlock = ({ seo, location }) => {
  return (
    <Flex bg="purple.500" justifyContent="center" alignItems="center" py="4">
      <ShareOnSocial
        textToShare=""
        link={location.href}
        linkTitle={seo.metaTitle}
        linkMetaDesc={seo.metaDescription}
        linkFavicon={favicon}
        noReferer>
        <Button
          bg="none"
          display="flex"
          justifyContent="center"
          alignItems="center"
          _hover={{
            textDecoration: `underline`
          }}
          _focus={{ bg: `none` }}
          _active={{ bg: `none` }}>
          <FiShare size={20} />
          <HeaderFont pl="2" fontWeight="700" lineHeight="1">
            Share this page
          </HeaderFont>
        </Button>
      </ShareOnSocial>
    </Flex>
  );
};

export default SharePageBlock;
